import { appRoutes } from 'app/app-routes';
import { UserActionCodeValues } from 'common/types/user-action-code';
import { UserActionCode, useUsersVerifyEmailCodeMutation } from 'graphql/generated';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { cacheActions } from 'redux/cache.slice';
import InfoPage from 'stories/layout/InfoPage';

type RouteParams = Record<'email' | 'code', string>;

const VerifyEmailCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { email, code } = useParams<RouteParams>();
  const [checked, setChecked] = useState(false);
  const [runVerify] = useUsersVerifyEmailCodeMutation();

  const checkCode = useCallback(async () => {
    try {
      if (email && code) {
        if (!checked) {
          setChecked(true);
          const payload = await runVerify({
            variables: { email, code },
          });
          if (!payload.data) throw new Error('Register user error');
          const result = payload.data.usersVerifyEmailCode;
          if (result.code === UserActionCode.verified && result.user) {
            const { __typename, ...user } = result.user;
            dispatch(cacheActions.user(user));
            navigate(appRoutes.home);
            dispatch(
              cacheActions.addSnack({
                message: UserActionCodeValues[result.code],
                variant: 'success',
              }),
            );
          }
        }
      } else navigate(appRoutes.errorPage);
    } catch (error: any) {
      dispatch(
        cacheActions.addSnack({
          message: error.message,
          variant: 'error',
        }),
      );
    }
  }, [email, code, runVerify, checked, dispatch, navigate]);

  useEffect(() => {
    checkCode();
  }, [checkCode]);

  const sendVerification = () => {
    if (email) navigate(`${appRoutes.verifyEmail}/${email}`);
    else navigate(appRoutes.errorPage);
  };

  const infoHeader = 'Email Verification';

  return (
    <InfoPage
      header={infoHeader}
      message1={
        checked
          ? `Your email could not be verified. Verify you have selected the correct verification email, or click 'Send Again' to send a new verification email.`
          : 'Checking code...'
      }
      actionLabel="Send Again"
      action={sendVerification}
    />
  );
};

export default VerifyEmailCode;
